import React from 'react';
import OnboardingForm from './components/OnboardingForm';

function App() {
  return <OnboardingForm />;
}

export default App;
